// ============================================================
// BOLD BRASILEIRO — Counter animado
// Anima o valor de [data-counter] quando entra no viewport
// ============================================================

(function () {
    'use strict';

    const elements = document.querySelectorAll('[data-counter]');
    if (!elements.length) return;

    /**
     * Anima de 0 até o valor original, preservando prefixo/sufixo
     * Ex: "+2.140" → anima 0 → 2140 e mantém o "+" e o "."
     *     "4.9"   → anima 0 → 4.9 com 1 casa decimal
     */
    const animate = (el) => {
        const finalText = el.getAttribute('data-counter') || el.textContent;

        // Detecta prefixo e sufixo não-numéricos
        const match = finalText.match(/^(\D*)([\d.,]+)(\D*)$/);
        if (!match) return;

        const prefix    = match[1];
        const numberRaw = match[2];
        const suffix    = match[3];

        // Detecta casas decimais e separador
        const hasDot   = numberRaw.includes('.');
        const hasComma = numberRaw.includes(',');
        // Brasileiro: 2.140 = milhar, 4,9 = decimal. Heurística simples:
        let decimals = 0;
        let target;

        if (hasComma) {
            // Ex: 4,9 ou 1.234,56
            target = parseFloat(numberRaw.replace(/\./g, '').replace(',', '.'));
            decimals = (numberRaw.split(',')[1] || '').length;
        } else if (hasDot) {
            // Ambíguo: 2.140 (milhar BR) ou 4.9 (decimal)
            // Heurística: se tem 3 dígitos após o ponto, é milhar
            const afterDot = numberRaw.split('.')[1] || '';
            if (afterDot.length === 3) {
                target = parseInt(numberRaw.replace(/\./g, ''), 10);
                decimals = 0;
            } else {
                target = parseFloat(numberRaw);
                decimals = afterDot.length;
            }
        } else {
            target = parseInt(numberRaw, 10);
            decimals = 0;
        }

        const duration = 1800;
        const start    = performance.now();

        const format = (n) => {
            if (decimals > 0) {
                return n.toFixed(decimals).replace('.', ',');
            }
            // milhar com ponto (formato BR)
            if (target >= 1000) {
                return Math.round(n).toLocaleString('pt-BR');
            }
            return Math.round(n).toString();
        };

        const step = (now) => {
            const elapsed = now - start;
            const progress = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
            const current = target * eased;
            el.textContent = prefix + format(current) + suffix;

            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                el.textContent = prefix + format(target) + suffix;
            }
        };

        requestAnimationFrame(step);
    };

    if (!('IntersectionObserver' in window)) {
        elements.forEach(animate);
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    animate(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.4 }
    );

    elements.forEach(el => observer.observe(el));
})();
